import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntilDestroy } from '@ngneat/until-destroy';

import { BoardConfiguration, BoardOutputTypeList } from '@main-application/boards/interfaces/board';
import { ButtonType } from '@shared/enums/button-type';
import { RestTurnoverTaskModel } from '@shared/interfaces/turnover.interface';

export class ScheduleDoneDialogData {
  turnover: RestTurnoverTaskModel;
  board: BoardConfiguration;
}

export class ScheduleCellResult {
  rememberIt: boolean;
}

@UntilDestroy()
@Component({
  selector: 'app-schedule-done-dialog',
  templateUrl: './schedule-done-dialog.component.html',
  styleUrls: ['./schedule-done-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScheduleDoneDialogComponent implements OnInit {
  form = this.formBuilder.group({
    rememberIt: [false],
  });
  ButtonType = ButtonType;
  inputItem: string;
  outputName: string;
  boardName: string;

  constructor(
    public dialogRef: MatDialogRef<ScheduleDoneDialogComponent, ScheduleCellResult>,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: ScheduleDoneDialogData
  ) {}

  ngOnInit(): void {
    this.boardName = this.data.board.name;
    this.inputItem = this.data.turnover.unitName;
    this.outputName = BoardOutputTypeList.find(e => e.value == this.data.board.outputAction).label;
  }

  ok() {
    this.dialogRef.close({
      rememberIt: this.form.value.rememberIt,
    });
  }

  cancel() {
    this.dialogRef.close();
  }
}
